import { Box, Stack, Text } from "@mantine/core";
import classes from "../..//Home.module.css";
import { useTranslation } from "react-i18next";
import OpenLeadItem from "./OpenLeadItem";
import OpenLeadsListQuery from "./OpenLeadsListQuery";

export default function OpenLeadsList() {
  const { t } = useTranslation("features");

  const { leads } = OpenLeadsListQuery();

  if (leads.length == 0) {
    return (
      <Box className={classes.listContainer}>
        <Box className={classes.noListItem}>
          <Text w={"100%"} className={classes.listNoItemsText}>
            {t(`home.noRecentLeads`)}
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Stack className={classes.listContainer} gap={8}>
      {leads.map((lead, index) => {
        return <OpenLeadItem key={index} lead={lead} />;
      })}
    </Stack>
  );
}
